import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/nivelPrioridad/importer/nivelPrioridadImporterActions';

export default importerReducers(actions);
